import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap, map } from 'rxjs/operators';

import {GetScheduleModel} from '../../../models/fee-schedule/get-schedule.model';
import {CreateScheduleModel} from '../../../models/fee-schedule/create-schedule.model';
import {FeeScheduleDataModel} from '../../../models/fee-schedule/fee-schedule-data.model';
import {PatientInsuranceDataModel} from '../../../models/patient/patient-insurance-data.model';
import {FeeScheduleItemDataModel} from '../../../models/fee-schedule/fee-schedule-item-data.model';
import {DataFeeScheduleItemFee4FeesJoinedModel} from '../models/data-fee-scheduleItem-fee4fees-joined.model';
import {PatientInsuranceCoverageDataModel} from '../../../models/patient/patient-insurance-coverage-data.model';
import {FeeScheduleDoctorDataModel} from '../../../models/fee-schedule/fee-schedule-doctor.model';
import {InsuranceExplosionCodeDataModel} from '../../../models/insurance/insurance-explosion-code-data.model';
import {InsuranceExplosionDataModel} from '../../../models/insurance/insurance-explosion-data.model';
import {FeeScheduleListViewDataModel} from '../models/fee-schedule-list-view.model';
import {DataARPaymentPlanModel} from '../../../models/accountsReceivable/data-ar-payment-plan.model';
import {dataPatientInsurance} from '../../ar/_models/ar.models';
import {ContactDataModel} from '../../../models/person/contact-data.model';
import {FeeAdjustmentsModel} from '../models/fee-adjustments.model';
import {FeeScheduleItemsHModel, FeeScheduleItemsModel} from "../models/fee-schedule-items.model";
import {FeeScheduleDocFeeModel} from "../models/fee-schedule-doc-fee.model";
import {csvItem} from "../fee-schedule-import-cvs/fee-schedule-import-cvs.component";

@Injectable({
  providedIn: 'root'
})
export class FeeScheduleService {
  currentFeeScheduleDoctor: any;

  constructor(private http: HttpClient) { }

  setFeeScheduleDoctor(feeScheduleDoctor: any) {
    this.currentFeeScheduleDoctor = feeScheduleDoctor;
  }

  getFeeScheduleDoctor() {
    return this.currentFeeScheduleDoctor;
  }

  clearFeeScheduleDoctor() {
    this.setFeeScheduleDoctor(null);
  }

  getDataPatientById(dataPatientId: string): Observable<any> {
    return this.http
      .get<any>(
        `/api/feeSchedule/getPatientById/${dataPatientId}`
      )
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('getDataPatientById'))
      );
  }

  getDataInsurances(): Observable<any> {
    return this.http.get<any>('/api/feeSchedule/getDataInsurances')
      .pipe(catchError(this.handleError<any>('getDataInsurances')));
  }

  editFeeSchedule(editSchedule: FeeScheduleListViewDataModel): Observable<FeeScheduleListViewDataModel> {
    return this.http.post<any>('/api/feeSchedule/editFeeSchedule', editSchedule)
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('editFeeSchedule'))
      );
  }

  createFeeSchedule(createScheduleObject: CreateScheduleModel): Observable<any> {
    return this.http.post<any>('/api/feeSchedule/createFeeSchedule', createScheduleObject)
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('createFeeSchedule'))
      );
  }

  saveFeeScheduleItem(feeScheduleItem: DataFeeScheduleItemFee4FeesJoinedModel): Observable<any> {
    return this.http.post<any>('/api/feeSchedule/saveItem', feeScheduleItem)
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('saveFeeScheduleItem'))
      );
  }

  getAllSchedulesByOrganization(OrganizationID: string): Observable<any> {
    return this.http.get<any>(`/api/feeSchedule/getAllSchedulesByOrganization/${OrganizationID}`);
  }

  createNewFeeScheduleItem(feeScheduleItem: DataFeeScheduleItemFee4FeesJoinedModel): Observable<DataFeeScheduleItemFee4FeesJoinedModel> {
    return this.http.post<any>('/api/feeSchedule/createFeeScheduleItem', feeScheduleItem)
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('createNewFeeScheduleItem'))
      );
  }

  // fetchExplosions(TDOCID: string, organizationID: string): Observable<any> {
  //   const httpOptions = {
  //     headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  //   };
  //   return this.http.get<any>(`/api/FeeScheduleItemDataModel/getExplosions/${TDOCID}/${organizationID}`, httpOptions);
  // }

  saveExplosion(explosion: InsuranceExplosionDataModel): Observable<any> {
    return this.http.post<any>('/api/feeSchedule/saveExplosion', explosion);
  }

  saveExplosionCode(explosionCode: InsuranceExplosionCodeDataModel): Observable<any> {
    return this.http.post<any>('/api/feeSchedule/saveExplosionCode', explosionCode);
  }

  getFeeScheduleDataModel(FeeScheduleID: string): Observable<any> {
    return this.http.get<any>(`/api/feeSchedule/getFeeSchedule/${FeeScheduleID}`)
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('getFeeScheduleDataModel'))
      );
  }

  getAllFeeSchedulesByDoctorID(doctorId: string): Observable<FeeScheduleDataModel[]> {
    return this.http.get<FeeScheduleDataModel[]>(`/api/feeSchedule/getAllFeeSchedulesByDoctorID/${doctorId}`)
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('getAllFeeSchedulesByDoctorID'))
      );
  }

  getAllFeeSchedules(): Observable<FeeScheduleDataModel[]> {
    return this.http.get<FeeScheduleDataModel[]>(`/api/feeSchedule/getAllFeeSchedules`)
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('getAllFeeSchedules'))
      );
  }




  getFeeSchedule(getScheduleObject: GetScheduleModel): Observable<FeeScheduleDataModel[]> {
    return this.http.get<FeeScheduleDataModel[]>(`/api/feeSchedule/getFeeSchedules/${getScheduleObject.doctorID}/${getScheduleObject.organizationID}`)
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('getFeeSchedule'))
      );
  }

  getOrganizationsByType(organizationType: string): Observable<any> {
    return this.http.get<any>(`/api/feeSchedule/getAllOrganizationsByType/${organizationType}`)
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('getOrganizations'))
      );
  }

  getOrganizations(): Observable<any> {
    return this.http.get<any>(`/api/feeSchedule/getAllOrganizations`)
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('getOrganizations'))
      );
  }

  getInsuranceCoverages(patientInsuranceId: string): Observable<any> {
    return this.http.get<any>(`/api/feeSchedule/getPatientCoverages/${patientInsuranceId}`)
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('getInsuranceCoverages'))
      );
  }

  createInsuranceCoverage(coverage: PatientInsuranceCoverageDataModel): Observable<any> {
    return this.http.post<any>('/api/feeSchedule/createPatientCoverage', coverage)
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('createInsuranceCoverage'))
      );
  }

  updateFeeScheduleItem(item: any) {
    return this.http.post<any>(`api/feeSchedule/updateItem`, item)
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('updateFeeScheduleItem'))
      );
  }

  createFeeScheduleItem(item: any) {
    return this.http.post<any>(`api/feeSchedule/createItem`, item)
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('createFeeScheduleItem'))
      );
  }

  getEnumValidValueItemsByVVName(validValueName: string) {
    return this.http.get<any>(`/api/feeSchedule/getValidValueItemsByValidValueName/${validValueName}`)
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('getEnumValidValueItemsByVVName'))
      );
  }

  // do not use
  getEnumValidValueItems(validValueID: string) {
    return this.http.get<any>(`/api/feeSchedule/getValidValueItems/${validValueID}`)
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('getEnumValidValueItems'))
      );
  }

  updateInsuranceCoverage(coverage: PatientInsuranceDataModel): Observable<any> {
    return this.http.post<any>('/api/feeSchedule/updateCoverage', coverage)
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('updateInsuranceCoverage'))
      );
  }

  getExplosions(TDOCID: number): Observable<any> {
    return this.http.get<any>(`/api/feeSchedule/getExplosions/${TDOCID}`);
  }

  getMyScheduleItems(userId: string): Observable<any> {
    return this.http.get<any>(`/api/feeSchedule/getMyItems/${userId}`);
  }

  markExplosionAsDeleted(explosionID: string): Observable<any> {
    console.log('sending', explosionID);
    return this.http.post<any>(`/api/feeSchedule/markExplosionAsDeleted/${explosionID}`, {});
  }

  markItemAsDeleted(item: DataFeeScheduleItemFee4FeesJoinedModel): Observable<DataFeeScheduleItemFee4FeesJoinedModel> {
    return this.http.post<DataFeeScheduleItemFee4FeesJoinedModel>('/api/feeSchedule/markItemAsDeleted', item);
  }

  deleteInsuranceCoverage(coverage: PatientInsuranceDataModel): Observable<any> {
    return this.http.post<any>('/api/feeSchedule/deleteCoverage', coverage)
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('updateInsuranceCoverage'))
      );
  }

  removeSchedule(scheduleID: string) {
    return this.http.post<any>(`/api/feeSchedule/remove/${scheduleID}`, {})
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('removeSchedule'))
      );
  }

  // copyFeeScheduleDoctor(feeScheduleId: string, DoctorId: string, Description: string): Observable<FeeScheduleDoctorDataModel> {
  copyFeeScheduleDoctor(feeScheduleId: string, DoctorId: string, Description: string, DocFeeScheduleID: string): Observable<FeeScheduleDoctorDataModel> {
    return this.http.post<any>('/api/feeSchedule/copyFeeScheduleDoctor', {
      feeScheduleId,
      DoctorId,
      Description,
      DocFeeScheduleID
    })
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('copyFeeScheduleDoctor'))
      );
  }

  editFeeScheduleDoctor(dataDoctor): Observable<any> {
    return this.http.post<any>('/api/feeSchedule/editFeeScheduleDoctor', dataDoctor);
  }

  getAllActiveFeeSchedulesForInsuranceForDoctor(dataDoctor): Observable<any> {


    let r = this.http.post<any>('/api/feeSchedule/getAllActiveFeeSchedulesForInsuranceForDoctor', dataDoctor);

    console.log(r);

    return r;


  }


  createFeeScheduleDoctorPaste( origin_DocFeeScheduleID: string ,   FeeScheduleID: string, DoctorId: string, Description: string): Observable<FeeScheduleDoctorDataModel> {
    const DocFeeScheduleID = origin_DocFeeScheduleID;
    return this.http.post<any>('/api/feeSchedule/createFeeScheduleDoctorPaste', {
      DocFeeScheduleID,
      FeeScheduleID,
      DoctorId,
      Description,
    })
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('createFeeScheduleDoctor'))
      );
  }

  createFeeScheduleDoctor(FeeScheduleID: string, DoctorId: string, Description: string): Observable<FeeScheduleDoctorDataModel> {
    return this.http.post<any>('/api/feeSchedule/createFeeScheduleDoctor', {
      FeeScheduleID,
      DoctorId,
      Description,
    })
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('createFeeScheduleDoctor'))
      );
  }

  // TODO: Investigate if this is different in some way from other getDoctors calls in other services.  We need to consolidate where we can.
  getDoctors(): Observable<any> {
    return this.http.get<any>('/api/feeSchedule/getDoctorList')
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('getDoctors'))
      );
  }

  getScheduleItems(scheduleID: string): Observable<FeeScheduleItemDataModel[]> {
    return this.http.get<FeeScheduleItemDataModel[]>(`/api/feeSchedule/byScheduleID/${scheduleID}`)
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('getScheduleItems'))
      );
  }

  getScheduleItemsWithFees(docFeeScheduleID: string): Observable<DataFeeScheduleItemFee4FeesJoinedModel[]> {
    return this.http.get<DataFeeScheduleItemFee4FeesJoinedModel[]>(`/api/feeSchedule/byDocFeeScheduleID/${docFeeScheduleID}`)
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('getScheduleItemsWithFees'))
      );
  }

  getScheduleItemsWithFeesV2(docFeeScheduleID: string): Observable<FeeScheduleItemsHModel[]> {
    return this.http.get<FeeScheduleItemsHModel[]>(`/api/feeSchedule/byDocFeeScheduleIDV2/${docFeeScheduleID}`);




      // .pipe(
      //   tap(_ => { console.log('tap: ', _)   }),
      //   catchError(this.handleError<any>( 'error in getScheduleItemsWithFeesV2' ))
      // );
  }

  getScheduleItemsWithFeesTableV2(docFeeScheduleID: string): Observable<FeeScheduleItemsModel[]> {
    return this.http.get<FeeScheduleItemsModel[]>(`/api/feeSchedule/byDocFeeScheduleIDtable/${docFeeScheduleID}`)
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('getScheduleItemsWithFeesTableV2'))
      );
  }

  postDocFeeScheduleItemsV2(docFees: FeeScheduleDocFeeModel[]): Observable<any> {
    return this.http.post<any>('/api/feeSchedule/postUpdatesDoctorFees', docFees);

  }

  postImportFeeSceduleFees(FeeScheduleDoctorID : string , priceList :csvItem[] ) : Observable<any> {
    return this.http.post<any>(`/api/feeSchedule/postImportFeeScheduleFees/${FeeScheduleDoctorID}`, priceList);

  }


  getFeeScheduleDoctorById(FeeScheduleDoctorID): Observable<any> {
    return this.http.get<any>(`/api/feeSchedule/getDoctorByID/${FeeScheduleDoctorID}`)
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('getFeeScheduleDoctorById'))
      );
  }

  deleteFeeScheduleDoctor(FeeScheduleDoctorID: string): Observable<any> {
    return this.http.post<any>(`/api/feeSchedule/deleteFeeScheduleDoctor/${FeeScheduleDoctorID}`, {})
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('deleteFeeScheduleDoctor'))
      );
  }

  saveFeeScheduleItemFee(feeScheduleItemFee: any): Observable<any> {
    return this.http.post<any>('/api/feeSchedule/createFeeScheduleItemFee', feeScheduleItemFee)
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('saveFeeScheduleItemFee'))
      );
  }

  saveFeeScheduleCoverage(coverage: any): Observable<any> {
    return this.http.post<any>('/api/feeSchedule/savePatientCoverage', coverage)
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('saveFeeScheduleCoverage'))
      );
  }

  // updateFeeScheduleItemFee(feeScheduleItemFee: DataFeeScheduleItemFee4FeesJoinedModel): Observable<any> {
  //   return this.http.post<any>('/api/feeSchedule/changeFeeScheduleItemFee', feeScheduleItemFee)
  //     .pipe(
  //       tap(_ => { }),
  //       catchError(this.handleError<any>('updateFeeScheduleItemFee'))
  //     );
  // }

  updateFeeScheduleItemFee(feeScheduleItemFee: DataFeeScheduleItemFee4FeesJoinedModel): Observable<any> {
    return this.http.post<any>('/api/feeSchedule/updateFeeScheduleItemFee', feeScheduleItemFee)
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('updateFeeScheduleItemFee'))
      );
  }

  getFeeScheduleDoctorsByFeeScheduleID(FeeScheduleID: string): Observable<any> {
    return this.http.get<any>(`/api/feeSchedule/getDoctorsByScheduleID/${FeeScheduleID}`)
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<any>('getFeeScheduleDoctorsByFeeScheduleID'))
      );
  }

  getFeeCoveragesCalcTypes() {
    return this.http.get<any>('/api/feeSchedule/get-fee-coverage-calc-types');
  }

  getUCRInsuranceForOrganization(OrganizationID: string, TDOCID: string): Observable<any[]> {
    return this.http.get<any[]>(`/api/feeSchedule/getUCRInsuranceForOrganization/${OrganizationID}/${TDOCID}`);
  }

  updateUCRInsurance(OrganizationID: string, TDOCID: string, FeeScheduleID: string): Observable<number> {
    return this.http.post<number>(`/api/feeSchedule/updateUCRInsurance/${OrganizationID}/${TDOCID}/${FeeScheduleID}`, '');
  }

  updateFeeScheduleFeesByPCT(FeeScheduleID: string, updateModel: FeeAdjustmentsModel): Observable<number> {
    return this.http.post<number>(`/api/feeSchedule/update-fee-schedule-fees-by-pct/${FeeScheduleID}`, updateModel);
  }


















  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any) => {
      console.error(error);
      return of(result as T);
    };
  }

}
